
export const past2023 = {
  subTitle: '—— 西丽湖金融科技大学生挑战赛',
  subTitleEn: 'FinTechathon 深圳国际金融科技大赛',
  titleImg: require('@/assets/img/2023.png'),
  mobileTitleImg: require('@/assets/img/2023.png'),
  introduction: {
    subTitle: '微众银行金融科技高校技术大赛',
    subTitleEn: 'FinTechathon',
    // certificate: require('../../../assets/img/awards/certificate.png'),
    // mobileCertificate: require('../../../assets/img/awards/certificate-wap.png'),
    intro: [
      '12 月 18 日，在深圳市地方金融管理局、深圳市福田区人民政府、深圳市南山区人民政府战略指导下，由深圳大学、微众银行、深圳香蜜湖国际金融科技研究院等多方联合举办的“2023 深圳国际金融科技大赛（FinTechathon）——西丽湖金融科技大学生挑战赛”在深圳大学圆满收官并举行大赛颁奖典礼。',
      '本届大赛历时63天，经过初赛、复赛的层层筛选和激烈角逐后，为期 2 天的决赛在深圳大学举行，人工智能和区块链赛道的队伍在完成“36 小时黑客松”不间断封闭开发后进行现场答辩，产品经理赛道的队伍则在完成作品完整版创作后进行现场答辩。现场气氛紧张刺激，参赛者们不仅进行了一场酣畅淋漓的技术比拼，还经历了一场对其团队协作、心理素质和身体素质的考验。最终，区块链、人工智能、产品经理三个赛道的前三甲名单终于出炉，他们获得了总计 69 万元的奖金及区块链数字证书。以下为具体获奖名单：'
    ],
    poster: require('@/assets/transSave/resource/image/e0/ce/e0b61ed77b04a2dab887259caea498ce.jpeg'),
    video: 'https://v-blog.csdnimg.cn/asset/dd2e5b8fa7da0aa9d47c2a3f0bd35de4/2729fa9ef4722880a02ef5c173654814.mp4'
  },

  finalist: {
    // title: '入围决赛队伍',
    // subTitle: 'FINALIST',
    content: [
      {
        alias: 'first',
        title: '一等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/53/e7/538838dbeb1a3bd5981074db4fcb03e7.jpg'),
            title: 'Aa100K',
            alias: 'ai',
            type_title: '人工智能赛道',
            product: '《OncoFed—基于FATE的肿瘤诊断项目》',
            member: '储添翼、谷曼苏、张慕翔、周荣祺、乔晓晓 ',
            school: '南京大学、西安电子科技大学、华东师范大学、西北工业大学、武汉大学',
            pro_intro: '在分级医疗体系下，基层医疗机构与医院之间的医疗水平差异愈来愈大，为了响应国家对于基层医疗机构软硬件建设的财政倾斜以及构建“互联网+”模式，实现既有资源的共建共享，本项目基于横向联邦学习技术与深度学习技术，以FATE作为基础，搭建了一个医疗影像脑部肿瘤检测系统。本项目提供的联邦学习加智慧医疗的解决方案打破医疗数据的孤岛问题，以极低成本促进医疗资源下沉，提升中西部地区与基层医疗机构的服务能力和水平。'
          },
          {
            image: require('@/assets/transSave/resource/image/27/53/275972e3810c6a9129f4c3459ee21a53.jpg'),
            title: '啊对对队',
            product: '《AI4C——面向AIGC创作的文化数字产品运营平台》',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '于祯奇、胡鑫、孙俨、杨国铭',
            school: '北京邮电大学',
            pro_intro: '目前，AIGC文化创作面临海量素材难存查、链下推理不可信、产品版权难保护、利益分配不透明等诸多难题。为解决以上问题，团队构建面向文化数字产品AIGC创作的版权运营平台。平台集成可信版权标识等6大关键功能，实现文化数字作品版权全流程服务。开展链上存储检索、链下可信扩展技术研究，设计文化数字产品运营方案。已完成平台与FISCO BCOS区块链的研发部署，并使用可信计算硬件支撑生成式模型的隐私计算与推理加速。'
          },
          {
            image: require('@/assets/transSave/resource/image/09/52/09c154975aafdc394b9c7317196e0d52.jpg'),
            title: '发际线和我作队',
            product: '《基于交互式对话的微众银行数字管家》',
            alias: 'pm',
            type_title: '产品经理赛道',
            member: '李世中、崔茜宁、曾梓莹',
            school: '北京航空航天大学、中国传媒大学、ESCP商学院',
            pro_intro: '在使用微众银行App时，用户在财富管理的全过程中缺乏引导与陪伴。交互式对话智能客服小微从这一痛点出发，在售前、售中、售后场景下为用户提供投资者教育、基金筛选、基金分析、持仓解读和投后分析等诸多功能。与传统智能客服相比，小微输出的交互式对话基于大语言模型技术生成，能够更好地理解客户输入并给出有温度的回复。小微还会不断基于交互式对话历史记录对客户画像进行完善，在交互过程中提供个性化的使用体验。'
          }
        ]
      },
      {
        alias: 'second',
        title: '二等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/cb/bb/cb319091e6438f379665b60e9c2380bb.jpg'),
            title: '联邦大模型前途无量对不队',
            product: '基于Langchain + FATE-ChatGLM3-6B的ESG报告生成器',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '王隆、高云龙、薛雨坤、李伟、杨科琅',
            school: '深圳大学',
            pro_intro: 'ESG智慧助手是一项创新人工智能项目，专注于解决环境、社会和公司治理（ESG）领域的挑战。为满足个人、机构投资者、专业咨询机构和企业管理层的需求，我们整合了公开数据并采用先进技术框架，打造了一套全面的解决方案。项目基于Langchain和FATE-ChatGLM3，结合LoRA、RLHF微调和动态Agent技术框架，保障了系统高效运作。全流程数据安全保护系统和强大补救机制确保用户数据隐私和安全。该项目适用于在FATE-LLM框架上进行集群部署，为ESG领域提供更智能的支持。',
          },
          {
            image: require('@/assets/transSave/resource/image/ef/82/efe1f3103a7b3e278c970e322a584c82.jpg'),
            title: 'find your dream',
            product: '基于FISCO BCOS的联邦学习平台',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '马昊滨、苏炳权',
            school: '广东工业大学',
            pro_intro: '该平台创新性地整合了联邦学习与区块链技术，实现了高效而安全的业务流程。首创串行+并行的联邦学习方式，巧妙提升了训练数据的多样性，减轻数据存储的压力，最大程度地保护了隐私安全。系统采用FISCO BCOS多群组部署和Ribbon负载均衡相结合，显著提升了区块链服务的处理效率与吞吐量。利用RocketMQ实现削峰确保了系统的稳定性；同时采用模型文件与文件索引分开存储的方式实现了大数据量文件上链存证的功能。通过公私钥文件实现节点可信认证，为整个系统提供了安全的基石。',
          },
          {
            image: require('@/assets/transSave/resource/image/56/99/565f6f03e5c9f0cb30f6580d4f478599.jpg'),
            title: '欢乐农场主',
            product: '家庭财富农场——基于对话式交互的理财小程序',
            alias: 'pm',
            type_title: '产品经理赛道',
            member: '戚煜格、王小东、朱志盈、谢立夫',
            school: '浙江大学',
            pro_intro: '家庭财富农场是一款基于对话式交互的理财小程序，通过模拟家庭资金池的形式为家庭三代成员提供个性化理财服务。儿童用户通过在农场中养小动物的形式，培养理财观念，学会管理零花钱和压岁钱等小额资金。中年用户可以在农场中审核儿童和老年人的理财产品和消费情况，实现家庭成员之间的资金协作。老年用户以购买储蓄类理财产品为主，小程序提供简洁而安全的提示，满足老年人的理财需求。',
          }
        ]
      },
      {
        alias: 'third',
        title: '三等奖',
        list: [
          {
            image: require('@/assets/transSave/resource/image/23/7f/23cce4032bd28f012fa5635c344af17f.jpg'),
            title: 'JZLab',
            product: '安联医盟—基于FATE+ABY的高效医疗数据联邦学习系统',
            alias: 'ai',
            type_title: '人工智能赛道',
            member: '付艺超、高一杰、牛晓丹',
            school: '暨南大学',
            pro_intro: '联邦学习是隐私保护医疗数据分析的有效工具之一，但存在通信效率低、无法有效处理异构医疗数据等问题，故此，本产品创新性地提出基于联邦学习开源框架FATE＋安全多方计算框架ABY的高效医疗数据联邦学习系统，通过将ABY引入FATE提高联邦学习通信效率，并采取数据增强和基于客户端贡献度的聚合算法解决数据异构问题。系统具有高效、灵活适配异构数据等优势，可广泛应用于疾病预测、医疗智能等场景。',
          },
          {
            image: require('@/assets/transSave/resource/image/6a/b5/6aaa20065a6d8874947bdaedb91b82b5.jpg'),
            title: 'TIDAL',
            product: '基于区块链的供应链碳足迹一元化系统',
            alias: 'blockchain',
            type_title: '区块链赛道',
            member: '邓淏天、梁浩天、王炜杰、轩浩钧、任旭豪',
            school: '北京理工大学',
            pro_intro: '传统供应链厂商通常将碳足迹数据存储在各自的本地数据库中，导致不同供应链厂商之间的数据库数据无法流通，造成了碳足迹数据难以同步的问题。本作品提出“基于区块链的供应链碳足迹一元化系统”。该系统由三个关键技术组成，包括面向区块链的细粒度访问控制技术、链上链下混合存储的体系架构以及高效的链上链下协同机制。该系统实现了各供应链厂商间数据的同步和一致，从而助力企业实现“双碳”目标。',
          },
          {
            image: require('@/assets/transSave/resource/image/98/28/9877c9ef99079da0327701bf36043128.jpg'),
            title: '穿梭在银河的火箭队',
            product: '好基比比',
            alias: 'pm',
            type_title: '产品经理赛道',
            member: '蒋宜芳、王泺然、刘思怡',
            school: '哈尔滨工业大学、北京林业大学、东北大学',
            pro_intro: '为应对选基指标日趋复杂的现状，“好基比比”能在基金比选决策环节，基于AIGC能力为用户提供易懂的、结合生活实例的个性化投资教学，降低理解成本。对新手，它提供逐步引导，支持双击解读图表及文本，助力用户建立完整知识体系；有投资经验的用户可自主组合数据维度，提升选基效率。“好基比比”旨在发展智能管家小微能力，助力微众银行普惠金融理念，满足不同用户在投资决策时的金融知识学习需求，使金融服务更加便捷、平等。',
          }
        ]

      }
    ]
  },


  videos: {
    titleCh: '直播回顾',
    titleEn: '',
    list: [
      {
        imgUrl: require('@/assets/transSave/resource/image/67/9f/67b00ba19eb09055628ed6f7a003cd9f.jpg'),
        contentText: '2023 深圳国际金融科技大赛暨微众银行 2024 校园招聘宣讲会',
        video: 'https://live.csdn.net/room/csdnstudent/QDKRpQPV'
      },
      {
        imgUrl: 'https://static001.infoq.cn/resource/image/a4/94/a4437eafcfec948de761ef55d9611194.jpg',
        contentText: '2023 深圳国际金融科技大赛-西丽湖金融科技大学生挑战赛线上公开课',
        video: 'https://live.csdn.net/room/csdnstudent/7LF1QRfn'
      },
      {
        imgUrl: 'https://static001.infoq.cn/resource/image/aa/8f/aaf29524fa250395a133434cb379888f.jpg',
        contentText: '2022 深圳国际金融科技大赛「AI 前沿应用与赛事通关法宝」',
        video: 'https://live.csdn.net/room/csdnstudent/fymHiNxW'
      },
      {
        imgUrl: 'https://static001.infoq.cn/resource/image/c6/37/c617b62feb2990e3bfb92a0f016e0837.jpg',
        contentText: '2022 深圳国际金融科技大赛「绿色金融科技分享」',
        video: 'https://live.csdn.net/room/csdnstudent/A0WssIsG'
      },
      {
        imgUrl: 'https://static001.infoq.cn/resource/image/48/97/4836618084cb353f814568fbecaa3d97.jpg',
        contentText: '2022 深圳国际金融科技大赛「区块链助力可持续发展」',
        video: 'https://live.csdn.net/room/csdnstudent/SF7NjWFc'
      }
    ],
    buttonText: '',
    buttonLink: ''
  }
}
